/* eslint-disable react/prop-types */
import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import { useLocations, LocationsContextProvider } from '@bluefin/components';

import { getDefaultActiveLocation, formatLocations } from './LocationsContextWrapper.utils';

function LocationsContextWrapper({
  defaultActiveLocationId = null,
  defaultToPrimary = false,
  useStorage = false,
  children = null,
}) {
  const data = useStaticQuery(graphql`
    query {
      fishermanBusinessProduct {
        uuid
      }
      allFishermanBusinessLocation {
        nodes {
          _id
          city
          country
          email
          hourLabels
          latitude
          longitude
          name
          order
          phoneNumber
          primaryLocation
          state
          street
          timezone
          uuid
          verifiedAddress
          zipCode
          hours {
            close
            day
            label
            location
            open
            openAllDay
            _id
          }
        }
      }
    }
  `);

  const {
    allFishermanBusinessLocation: { nodes: locations = [] },
    fishermanBusinessProduct,
  } = data;
  const { uuid: productUuid } = fishermanBusinessProduct;

  const locationsOptions = {
    useStorage,
    defaultToPrimary,
    initialActiveLocation: getDefaultActiveLocation(locations, defaultActiveLocationId),
    siteId: productUuid,
  };

  const formattedLocations = formatLocations(locations);

  const contextValue = useLocations(formattedLocations, locationsOptions);

  return <LocationsContextProvider value={contextValue}>{children}</LocationsContextProvider>;
}

export default LocationsContextWrapper;
